import { QITable, QISlideSelect, QISpinner } from "../../../../components";
import { useEffect, useMemo, useState } from "react";
import { getLocalizedString } from "../../../../shared/translation";
import { capitalize } from "../../utils";
import moment from "moment";

const LOAD_MORE_THRESHOLD = 0.9;

const TripsListWrapper = ({
  tracksData,
  batchSize,
  onBatchSizeChange = () => {},
  hasMore,
  isLoadingMore,
  onLoadMore = () => {},
  setActivitiesTimeRange = () => {},
  selectedId,
}) => {
  const timeConversion = (time) => {
    if (time === null || time === undefined) return "-";
    return moment(time)?.format(" DD/MM/YY - hh:mm:ss A");
  };

  const getLocation = (position) => {
    if (position?.address?.name) return position?.address?.name;
    if (
      position?.lat === undefined ||
      position?.lng === undefined ||
      position?.lat === null ||
      position?.lng === null
    )
      return "-";
    return position?.lat + "," + position?.lng;
  };

  const [updatedData, setUpdatedData] = useState([]);

  const headers = [
    {
      label: getLocalizedString("mode", "Mode"),
      key: "modes",
      className: "mode",
    },
    {
      label: getLocalizedString("status", "Status"),
      nestedValue: true,
      getNestedValue: ({ status }) => {
        status = status?.replace("_", " ");
        return <h1 title={capitalize(status)}>{capitalize(status)}</h1>;
      },
      className: "status-activities",
    },
    {
      label: getLocalizedString("start_time", "Start Time"),
      key: "start_time",
      className: "start-time",
    },
    {
      label: getLocalizedString("start_location", "Start Location"),
      key: "start_location",
      className: "start-location",
    },
    {
      label: getLocalizedString("end_time", "End Time"),
      key: "end_time",
      className: "end-time",
    },
    {
      label: getLocalizedString("end_location", "End Location"),
      key: "end_location",
      className: "end-location",
    },
  ];

  useEffect(() => {
    setUpdatedData(
      tracksData?.map((data) => {
        return {
          ...data?.data,
          start_time: timeConversion(data?.data?.start_time),
          modes: capitalize(data?.data?.modes),
          status: capitalize(data?.data?.status),
          end_time: timeConversion(data?.data?.end_time),
          start_location: getLocation(data?.data?.start_position),
          end_location: getLocation(data?.data?.end_position),
          epoch_start_time: data?.data?.start_time,
          epoch_end_time: data?.data?.end_time,
        };
      })
    );
  }, [tracksData]);

  const batchControl = useMemo(
    () => ({
      page: 1,
      perPage: batchSize,
      onPageChange: () => {},
      onPerPageChange: onBatchSizeChange,
    }),
    [batchSize, onBatchSizeChange]
  );

  return (
    <>
      <QITable
        headers={headers}
        data={updatedData}
        className="activities"
        showSelected={true}
        selectedId={selectedId}
        handler={{
          rowHandler: (data) => {
            setActivitiesTimeRange({
              start_time: data?.epoch_start_time,
              end_time: data?.epoch_end_time,
            });
          },
        }}
        onScrollFrame={({ top }) => {
          if (top >= LOAD_MORE_THRESHOLD && hasMore && !isLoadingMore) {
            onLoadMore();
          }
        }}
      />
      <aside className="qi-pagination-wrapper">
        <QISlideSelect pagination={batchControl} />
        {isLoadingMore && <QISpinner size="20px" />}
      </aside>
    </>
  );
};

export default TripsListWrapper;
